import { ActionButton, CudaDialogTitle, LoadingDialogContent } from 'common/components/CudaDialog'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { Field } from 'redux-form'
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { renderTextField } from 'common/form/fields'
import validator from 'common/form/validator'
import { withStyles } from '@material-ui/core/styles';

const style = {
    root: {
        '& input, textarea': {
            width: '100%',
        }
    },
    fieldLabel: {
        display: 'flex',
        alignItems: 'center'
    },
}

const validateTimeout = value => validator.required(value) || validator.maxValue(3600)(value);

const AllowDenyDialog = ({ classes, isOpen, loading, submitting,
    close,
    handleSubmit,
    }) => {

    return (
        <form onSubmit={handleSubmit}>
            <Dialog open={isOpen} transitionDuration={0} maxWidth="md" onClose={close} className={classes.root}>
                <CudaDialogTitle onRequestClose={close}>
                Advanced Options
                </CudaDialogTitle>
                <LoadingDialogContent loading={loading || submitting}>
                    <Grid container alignItems='center'>

                        <Grid item xs={6} className={classes.fieldLabel}>
                        Session Timeout:
                        </Grid>

                        <Grid item xs={6}>
                            <Field
                                name="session_timeout"
                                component={renderTextField}
                                className={classes.input}
                                validate={validateTimeout}
                                autoFocus
                            />
                        </Grid>

                    </Grid>
                </LoadingDialogContent>
                <DialogActions>
                    <ActionButton onClick={close}>
                        Cancel
                    </ActionButton>
                    <ActionButton color="primary" onClick={handleSubmit}>
                        Save
                    </ActionButton>
                </DialogActions>

            </Dialog>
        </form>
    );
};

export default withStyles(style, { name: 'allowDenyDialog' })(AllowDenyDialog);
